import { createContext, useContext } from "react";

export interface Admin {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  role: "SUPER" | "ORGANIZATION" | "BUSINESS_UNIT" | "FINANCE";
  organizationId?: string;
  businessUnitId?: string;
  avatarUrl?: string;
  isImpersonating?: boolean;
}

export interface AuthContextType {
  user: Admin | null;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  refreshUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
